import { motion } from "framer-motion";
import { Users } from "lucide-react";
import { IMAGES } from "./data";

// Credentials displayed as a typographic row — no fake logos.
const INSTITUTIONS = [
  "Universidade Federal de Uberlândia",
  "Instituto do Sono",
  "Sleep Tight",
  "Faculdade Brasília",
];

export default function AuthorityStrip() {
  return (
    <section className="relative bg-[#fbf6ed] border-y border-violet-400/10 py-10 overflow-hidden">
      <div className="absolute inset-0 stars-bg opacity-10 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex flex-col lg:flex-row items-center gap-7 lg:gap-12"
        >
          {/* +600 famílias — main statement */}
          <div className="flex items-center gap-4 shrink-0">
            <div className="relative w-16 h-16 rounded-full overflow-hidden border-2 border-violet-300/50 shrink-0">
              <img
                src={IMAGES.marianaPortrait}
                alt="Mariana Mello"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="leading-tight">
              <p className="font-display text-[26px] lg:text-[30px] text-[#1f1430] leading-none">
                <span className="text-[#6d28d9] font-medium">+600 famílias</span>{" "}
                acompanhadas
              </p>
              <p className="text-[#6b5e7c] text-[13px] mt-2 inline-flex items-center gap-1.5">
                <Users className="w-3.5 h-3.5 text-[#a78bfa]" />
                Em consultoria de sono infantil por Mariana Mello
              </p>
            </div>
          </div>

          {/* Vertical divider */}
          <span className="hidden lg:block h-14 w-px bg-violet-400/20" />

          {/* Institutions */}
          <div className="flex-1">
            <p className="text-[10px] uppercase tracking-[0.18em] text-[#6d28d9]/80 font-bold mb-2 text-center lg:text-left">
              Formação por
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-2">
              {INSTITUTIONS.map((name, i) => (
                <span
                  key={i}
                  className="font-display italic text-[#1f1430]/80 text-[14px] lg:text-[15px] whitespace-nowrap"
                >
                  {name}
                  {i < INSTITUTIONS.length - 1 && (
                    <span className="text-[#a78bfa] ml-6">·</span>
                  )}
                </span>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
